module.exports = __webpack_public_path__ + "img/theme2.e4f21058.png";